import { i18n } from '@/shared/i18n';
import type { TaxonomyStatus } from '../model/types';

/** The status as a standalone label, the same words the status badge shows. */
export function taxonomyStatusLabel(status: TaxonomyStatus): string {
  switch (status) {
    case 'published':
      return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.published');
    case 'archived':
      return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.archived');
    default:
      return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.draft');
  }
}

/**
 * The status as a word inside a sentence about a version: lowercase in English,
 * and agreeing with the word for "version" where a language inflects it.
 */
export function taxonomyVersionStatusWord(status: TaxonomyStatus): string {
  switch (status) {
    case 'published':
      return i18n.t('knowledge:taxonomy.common.versionStatusPublished');
    case 'archived':
      return i18n.t('knowledge:taxonomy.common.versionStatusArchived');
    default:
      return i18n.t('knowledge:taxonomy.common.versionStatusDraft');
  }
}
